import Controller from '../abstracts/Controller';
//import Collapse from '../../../node_modules/bootstrap/js/src/Collapse';


export default class EditorialListingController extends Controller {
  static get COMPONENTS() {
    return [
      'ParallaxComponent',
      'DominationComponent',
      'HeroZoomComponent',
      'HeroZoomMobile',
      'WallComponent',
      'CarouselComponent',
      'ParallaxComponent',
      'VideoComponent',
      'DominationComponent',
      'VideoBrightcove',
      'LookBookComponent',
      'CardComponent',
      'BridalWeddingAppointmentComponent',
      'TogglesButtonComponent'
    ];
  }
}
